import styled from '@emotion/styled';

import { Typography } from '@/shared/design-system';

export const OfferDescription = styled(Typography)(({ theme }) => ({
  color: theme.colors.text.secondary,
  textAlign: 'center',
}));

export const OfferError = styled('div')(({ theme }) => ({
  color: theme.colors.text.error,
  textAlign: 'center',
}));
